import { AddButton } from "@/components/AddButton";
import { NavigationContainer } from "@/components/NavigationButton";
import { Box, Dialog, styled } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import { OtherSuppliesReportForm } from "./components/OtherSuppliesReportForm";
import { useQuery } from "@apollo/client";

import { SuppliesReportForm } from "./components/SuppliesReportForm";
import {
  SuppliesTable,
  currentSupplyDetails,
} from "./components/SuppliesTable";

const Body = styled(Box)`
  margin-top: 41px;
  margin-bottom: 96px;
`;

export const SuppliesReport = () => {
  const [otherDialogForm, setOtherDialogForm] = useState(false);
  const [dialogForm, setDialogForm] = useState(false);
  const [detailId, setDetailId] = useState<undefined | number>(undefined);

  const params = useParams();
  const navigate = useNavigate();

  const { data } = useQuery(currentSupplyDetails, {
    variables: { params: { id: +(params.id || 0) } },
  });

  const goBack = () => navigate(`/formulario-reporte/${params.id}/partidas`);
  const goNext = () => navigate(`/formulario-reporte/${params.id}/equipos`);

  const handleAddDefaultResource = (formDetailId: number) => {
    setDialogForm(true);
    setDetailId(formDetailId);
  };

  const selectedDetail = data?.report?.supplyDetails?.find(
    (detail) => detail.id === detailId
  );
  return (
    <Body>
      <SuppliesTable onEdit={(detail) => handleAddDefaultResource(detail.id)} />
      <AddButton variant="contained" onClick={() => setOtherDialogForm(true)}>
        <AddIcon />
        AGREGAR OTRO
      </AddButton>
      <Dialog
        open={otherDialogForm}
        onClose={() => setOtherDialogForm(false)}
        fullWidth
        PaperProps={{ sx: { maxWidth: 400 } }}
      >
        <OtherSuppliesReportForm close={() => setOtherDialogForm(false)} />
      </Dialog>

      <Dialog
        open={dialogForm}
        onClose={() => setDialogForm(false)}
        fullWidth
        PaperProps={{ sx: { maxWidth: 400 } }}
      >
        <SuppliesReportForm
          close={() => setDialogForm(false)}
          detail={{
            ...selectedDetail,
            incomeQuantity: selectedDetail?.incomeQuantity ?? undefined,
            initialQuantity: selectedDetail?.initialQuantity ?? undefined,
            finalQuantity: selectedDetail?.finalQuantity ?? undefined,
            comment: selectedDetail?.comment ?? "",
            photoUrl: selectedDetail?.photoUrl ?? undefined,
          }}
        />
      </Dialog>
      <NavigationContainer handleNext={goNext} handlePrev={goBack} />
    </Body>
  );
};
